import { createAction, createAsyncAction } from 'typesafe-actions';

import {
  GetParCouponHistoryPayload,
  GetPricingUpdateSchedulePayload,
  GetPricingUpdateSummariesPayload,
  ParCouponHistoryEntry,
  PricingUpdateContact,
  PricingUpdatePreview,
  PricingUpdateRun,
  PricingUpdateSchedule,
  PricingUpdateSchedulePayload,
  PricingUpdateSummary,
  PricingUpdateTradePayload,
  PricingUpdateValuation,
  SavePricingUpdateSchedulePayload,
} from './types';

export const getPricingUpdateSchedule = createAsyncAction(
  'dealPricingUpdates/getSchedule/request',
  'dealPricingUpdates/getSchedule/success',
  'dealPricingUpdates/getSchedule/failure',
)<
  GetPricingUpdateSchedulePayload,
  { data: PricingUpdateSchedule | null },
  undefined
>();

export const savePricingUpdateSchedule = createAsyncAction(
  'dealPricingUpdates/saveSchedule/request',
  'dealPricingUpdates/saveSchedule/success',
  'dealPricingUpdates/saveSchedule/failure',
)<
  SavePricingUpdateSchedulePayload,
  { data: PricingUpdateSchedule },
  undefined
>();

export const stopPricingUpdateSchedule = createAsyncAction(
  'dealPricingUpdates/stopSchedule/request',
  'dealPricingUpdates/stopSchedule/success',
  'dealPricingUpdates/stopSchedule/failure',
)<PricingUpdateSchedulePayload, undefined, undefined>();

export const removePricingUpdateTrade = createAsyncAction(
  'dealPricingUpdates/removeTrade/request',
  'dealPricingUpdates/removeTrade/success',
  'dealPricingUpdates/removeTrade/failure',
)<
  PricingUpdateTradePayload,
  { data: PricingUpdateSchedule | null },
  PricingUpdateTradePayload
>();

export const retryPricingUpdateValuation = createAsyncAction(
  'dealPricingUpdates/retryValuation/request',
  'dealPricingUpdates/retryValuation/success',
  'dealPricingUpdates/retryValuation/failure',
)<
  PricingUpdateTradePayload,
  { data: PricingUpdateValuation },
  PricingUpdateTradePayload
>();

export const getPricingUpdateSendHistory = createAsyncAction(
  'dealPricingUpdates/getSendHistory/request',
  'dealPricingUpdates/getSendHistory/success',
  'dealPricingUpdates/getSendHistory/failure',
)<PricingUpdateSchedulePayload, { data: PricingUpdateRun[] }, undefined>();

export const getPricingUpdatePreview = createAsyncAction(
  'dealPricingUpdates/getPreview/request',
  'dealPricingUpdates/getPreview/success',
  'dealPricingUpdates/getPreview/failure',
)<PricingUpdateSchedulePayload, { data: PricingUpdatePreview }, undefined>();

export const getPricingUpdateContacts = createAsyncAction(
  'dealPricingUpdates/getContacts/request',
  'dealPricingUpdates/getContacts/success',
  'dealPricingUpdates/getContacts/failure',
)<
  GetPricingUpdateSchedulePayload,
  { data: PricingUpdateContact[] },
  undefined
>();

export const getParCouponHistory = createAsyncAction(
  'dealPricingUpdates/getParCouponHistory/request',
  'dealPricingUpdates/getParCouponHistory/success',
  'dealPricingUpdates/getParCouponHistory/failure',
)<GetParCouponHistoryPayload, { data: ParCouponHistoryEntry[] }, undefined>();

export const getPricingUpdateSummaries = createAsyncAction(
  'dealPricingUpdates/getSummaries/request',
  'dealPricingUpdates/getSummaries/success',
  'dealPricingUpdates/getSummaries/failure',
)<
  GetPricingUpdateSummariesPayload,
  { data: PricingUpdateSummary[] },
  undefined
>();

export const resetPricingUpdates = createAction('dealPricingUpdates/reset')();

export const resetPricingUpdateSummaries = createAction(
  'dealPricingUpdates/resetSummaries',
)();
